import {
  createResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL_PREFIX = 'autocomplite'

const AUTOCOMPLETE_LINK = prefixAPI('/{label}/', MODEL_PREFIX)
const IDEA_UNITS_LINK = prefixAPI('/idea/unit/counter/', MODEL_PREFIX)
const IDEA_COUNTERS_LINK = prefixAPI('/idea/index/counter/', MODEL_PREFIX)
const NEWS_CATEGORY_LINK = prefixAPI('/news/category/', MODEL_PREFIX)
const NESTED_CATEGORY_LINK = prefixAPI('/category/nested/', MODEL_PREFIX)
const NESTED_CATEGORY_MAP_LINK = prefixAPI('/category/nested/map/', MODEL_PREFIX)
const PRODUCT_LIST_LINK = prefixAPI('/product/is_active={isActive};{query}', MODEL_PREFIX)

export const autocomleteResource = createResource(AUTOCOMPLETE_LINK)
export const ideaUnits = createResource(IDEA_UNITS_LINK)
export const ideaCounters = createResource(IDEA_COUNTERS_LINK)
export const newsCategory = createResource(NEWS_CATEGORY_LINK)
export const nestedCategory = createResource(NESTED_CATEGORY_LINK)
export const nestedCategoryMap = createResource(NESTED_CATEGORY_MAP_LINK)
export const productAutocomplete = createResource(PRODUCT_LIST_LINK)
